import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';

const NavigationEmail = () => {
  return (
    <div className="navigation-email-container">
      <div className="email">
        <EmailOutlinedIcon style={{ color: '#4db5ff' }} />
        <span className="email-text">nguyenphuctien1258@gmail.com</span>
      </div>
      <div className="phone">
        <LocalPhoneOutlinedIcon style={{ color: '#4db5ff' }} />
        <span className="phone-text">0944726281</span>
      </div>
    </div>
  );
};

export default NavigationEmail;
